import React from 'react';
import * as color from 'color';
import { Fa } from '../../elements/fa';
import { IconDefinition } from '@fortawesome/fontawesome';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import C from '../../../shared/constants';
import { iFullStoreState } from '../../../shared/interfaces';
import { isMobile } from '../../../shared/helpers';
import styles from './modal-actions.module.scss';

type IButtonProps = {
    fa?: IconDefinition;
    title: string;
    primary?: boolean;
    danger?: boolean;
    multiline?: boolean;
    smallText?: boolean;
    customClassName?: string;
    click?: () => void;
    link?: string;
}

type IProps = {
    buttons: Array<IButtonProps>;
    hidden?: boolean;
    isFence?: boolean;
    embedded?: boolean;
}

const ModalActionsComponent: React.FunctionComponent<IProps> = (props) => {
    const {isFence = false, hidden, buttons, children, embedded = false} = props;

    const fenceEditMode = useSelector<iFullStoreState, boolean>(s => s.fences.isEditing);

    if (fenceEditMode && !isFence) {
        return null;
    }

    return (
        <div
          className={`${styles.modalActionsComponent} ${isMobile ? styles.mobile : ''} ${embedded ? styles.embedded : ''}`}
          style={{display: hidden ? 'none' : 'flex'}}
        >
            <div className={styles.buttonsContainer}>
                {buttons.map(plainButton)}
            </div>

            {children}
        </div>
    );
};

export default ModalActionsComponent;

const plainButton = ({fa, title, click, link, primary = false, danger = false, multiline = false, smallText = false, customClassName = ''}: IButtonProps) => {
    const buttonContent = fa ? <Fa icon={fa} style={{fontSize: 20}} /> : title;

    const buttonClassName = danger
        ? `${styles.dangerButton} mas-danger-button`
        : primary
            ? `${styles.primaryButton} mas-primary-button`
            : `${styles.nonPrimaryButton} mas-non-primary-button`;

    const contentClassName = [
      multiline ? styles.multilineText : '',
      smallText ? styles.smallText : '',
    ].filter(Boolean).join(' ');

    return link
        ? (
            <Link
                key={title}
                title={title}
                to={link}
                className={`btn ${buttonClassName} ${customClassName}`.trim()}
            >
                <span className={contentClassName}>{buttonContent}</span>
            </Link>
        )
        : (
            <span
                key={title}
                title={title}
                onClick={click}
                className={`btn ${buttonClassName} ${customClassName}`.trim()}
            >
                <span className={contentClassName}>{buttonContent}</span>
            </span>
        );
}